import logo from 'assets/images/neozorg_logo.png';
import logo_payoff from 'assets/images/neozorg_payoff.svg';
import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:82f95abe-e883-4afc-8555-6e0d541d704f',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_ZiFqO9JQO',
  aws_user_pools_web_client_id: '157fubr20pneas4ciajn916867',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://onmv6njgfrc75meppgys36yqom.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://6hznu3noa8.execute-api.eu-west-1.amazonaws.com/neo',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage102411-neo',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'neozorg.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'NeoZorg',
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: false,
  ENABLE_MEDICAL_PROFILE: false,
  ENABLE_MANAGEMENT: true,
  ENABLE_CLINICARDS: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_INSIGHTS: false,
  AWS,
  logo,
  logo_payoff,
  defaultCarepathCards,
  ENABLE_CHILD_PROFILE: true,
  DEFAULTCARDS: [
    '23as12xz-cea7-9923-bf8a-17d8cb552262',
    '54ds123sa-cea7-9923-12as-17d8cb552262',
    '54wsa12g-cea7-9923-bf8a-17d8cb552262',
    '62369046-980d-4ea6-9e78-1b1b69068e08',
    'de673886-5669-4e0d-b142-6fda146d2334',
    '7c91f545-4075-40a1-8f27-1e393b06bca4'
  ],
};
